import React from "react";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import Popup from "../popup/Popup";
import { useState } from "react";
import Controls from "../form/controls/Controls";

export const isShowCache = (currentActionCache, cache) => {
  return currentActionCache === cache;
};

const DeployCache = ({ children, title, isShowButton }) => {
  const [openPopup, setOpenPopup] = useState(false);
  return (
    <>
      {isShowButton ? (
        <Controls.Button
          text="Deploy Data"
          color="error"
          startIcon={<WarningAmberOutlinedIcon />}
          variant="outlined"
          onClick={() => setOpenPopup(true)}
        />
      ) : null}

      <Popup
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              marginTop: "-10%",
              width: "100%",
              maxWidth: "700px",
            },
          },
        }}
        title={title}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        {children}
      </Popup>
    </>
  );
};

export default DeployCache;
